import styled from 'styled-components';
import * as variables from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const DealerLPStyles = styled.div`
  margin-bottom: 30px;

  .area-hero {
    padding-bottom: 10px;
  }
  .dealer-hours,
  .dealer-info {
    padding-top: 20px;
  }
  .dealer-hours a {
    align-items: center;
    color: ${Colors.primary.black.standard};
    display: flex;
    flex-direction: row;
    font-family: 'acumin-pro', sans-serif;
    font-weight: bold;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: -0.3px;
    text-decoration: none;

    img.down {
      margin-left: 5px;
      transform: rotate(180deg);
    }
  }
  .dealer-phone {
    p {
      display: none;
    }
  }
  .dealer-address img,
  .dealer-phone img,
  .dealer-address svg,
  .dealer-phone svg {
    margin-right: 6px;
    margin-top: 6px;
  }

  .dealer-address {
    margin-bottom: 10px;
  }

  .dealer-address-text p,
  .dealer-phone {
    display: block;
  }

  .dealer-phone a:link,
  .dealer-phone a:visited,
  .dealer-phone a:hover,
  .dealer-phone a:active {
    color: ${Colors.primary.claytonBlue.standard};
  }

  .dealer-address {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
  }

  .dealer-info {
    margin-bottom: 20px;

    .dealer-website {
      display: none;
    }
  }

  .dealer-hours {
    margin-bottom: 20px;

    .dealer-hours-list {
      display: none;

      h6 {
        display: none;
      }
      &.shown {
        display: block;
      }
    }

    div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .dealer-actions {
    button {
      margin-bottom: 10px;
    }
  }
  .web-form-thank-you {
    text-align: center;

    svg {
      margin: 50px 0 30px 0;
    }
    p {
      max-width: 320px;
      margin: 30px auto 40px auto;
    }
    button {
      margin: 0 auto 20px auto;
      width: 100%;
    }
  }
  .mobile-form-button {
    margin-top: 10px;
  }

  .home-card-detailed {
    margin-bottom: 20px;
  }

  .modal-container {
    max-height: 90%;
    max-width: 400px;
    width: 90%;

    .modal-content {
      max-height: 100vh;
      padding: 20px;
      background-color: #ffffff;

      .dealer-modal-form {
        height: 100%;
        box-shadow: none;
        border-radius: 0;

        > div {
          padding-top: 20px;
        }
        .form-text,
        .form-header {
          display: none;
        }
        .disclaimer-text {
          padding-top: 5px;
          p {
            font-size: 12px;
          }
        }
        .web-form-thank-you {
          p {
            margin: 0;
          }
        }
      }
      .modal-form-header {
        padding: 0 20px;
        text-align: center;
      }
      .dealer-mobile-form {
        .form-header {
          font-style: normal;
          font-weight: bold;
          font-size: 20px;
          line-height: 24px;
          text-align: center;
        }

        .form-text {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 22px;
          text-align: center;
          margin-bottom: 20px;
        }
      }
      .disclaimer-checkbox {
        label {
          align-items: flex-start;

          &:before {
            margin-top: 6px;
          }
        }
      }
    }
  }

  .virtual-tour-modal {
    .modal-container {
      height: 90%;
      max-width: 90%;

      .modal-content {
        height: 100%;

        iframe {
          height: 90%;
          width: 100%;
        }
      }
    }
  }

  .dealer-desktop-form-container {
    display: none;
  }

  .dealer-desktop-form,
  .dealer-modal-form,
  .dealer-mobile-form {
    form .animated label {
      color: #545454;
    }
    h2 {
      font-size: 15px;
      margin-top: 10px;
    }
  }

  .cta {
    margin-bottom: 20px;
  }

  .cta-buttons a {
    margin-right: 20px;
  }

  @media only screen and (max-width: 550px) {
    .cta > div {
      background-image: none;
    }
  }

  @media only screen and (min-width: ${variables.desktop_breakpoint}px) {
    &.dealer-landing-page .area-hero {
      .area-info {
        .hero-heading {
          margin-top: 100px;
          text-align: left;
          width: calc(100% - 465px);
        }
      }
    }
    .dealer-page {
      padding-left: 0;
      padding-right: 0;
    }
    .dealer-info-hours {
      display: flex;
      flex-direction: row;
      margin-bottom: -200px;
      min-height: 500px;
    }
    .dealer-info,
    .dealer-hours {
      width: 300px;
    }

    .dealer-info .dealer-website {
      display: inline-block;
      margin-left: 20px;
      margin-top: 20px;
    }
    .dealer-phone {
      a {
        display: none;
      }
      p {
        display: inline;
      }
    }
    .dealer-hours {
      a {
        display: none;
      }
      .dealer-hours-list {
        border-left: ${Colors.accent.grey4.standard} 1px solid;
        display: block;
        margin: auto;
        padding-left: 20px;
        padding-right: 20px;
        width: 90%;

        h6 {
          display: inline-block;
        }
      }
    }
    .dealer-desktop-form-container {
      display: block;
      margin-left: auto;
      .dealer-desktop-form {
        width: 450px;

        h2 {
          text-align: center;
          font-size: 15px;
          margin-top: 10px;
        }
      }
    }
    .mobile-form-button {
      display: none;
    }
    .dealer-desktop-form,
    .dealer-modal-form,
    .dealer-mobile-form {
      background: #ffffff;
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      display: block;
      padding: 20px;
      position: relative;
      top: -200px;
      width: 350px;

      .form-header {
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
        text-align: center;
        letter-spacing: -0.3px;
      }
      .field-row:first-child {
        display: flex;
        justify-content: space-between;

        .field-column {
          width: 45%;
        }
      }
      .disclaimer-checkbox {
        label {
          align-items: flex-start;

          &:before {
            margin-top: 6px;
          }
        }
      }
    }

    .dealer-desktop-form {
      .form-text {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
      }
    }

    .dealer-modal-form,
    .dealer-mobile-form {
      top: 0;
    }

    .dealer-actions {
      display: none;
    }

    .cta > div {
      width: 100%;
      max-width: none;
    }
  }
`;
